import React from "react";

import {
  IAddOnOptionStore,
  IAddOnStore,
  IAllergenStore,
  IAuthStore,
  ICartStore,
  ICategoryStore,
  IDeliveryStore,
  IOrderStore,
  IProductOfferStore,
  IProductStore,
  IRootStore,
  IShopSettingsStore,
  IUserStore,
  IVoucherStore,
} from "./index.d";

import ProductStore from "./products/product-store";
import CartStore from "./cart/cart-store";
import AddOnStore from "./addOns/addOns-store";
import AddOnOptionStore from "./addOns/addOnOption-store";
import UserStore from "./users/user-store";
import AuthStore from "./auth/auth-store";
import OrderStore from "./order/order-store";
import ShopSettingsStore from "./shopSettings/shopSettings-store";
import DeliveryStore from "./delivery/delivery-store";
import AllergenStore from "./allergen/allergen-store";
import CategoryStore from "./productCategory/category-store";
import ProductOfferStore from "./productOffer/product-offer-store";
import VoucherStore from "./voucher/voucher-store";

class RootStore implements IRootStore {
  authStore: IAuthStore;
  productStore: IProductStore;
  addOnStore: IAddOnStore;
  addOnOptstore: IAddOnOptionStore;
  cartStore: ICartStore;
  orderStore: IOrderStore;
  userStore: IUserStore;
  shopSettingsStore: IShopSettingsStore;
  deliveryStore: IDeliveryStore;
  allergenStore: IAllergenStore;
  categoryStore: ICategoryStore;
  productOfferStore: IProductOfferStore;
  voucherStore: IVoucherStore;

  showLoader: boolean;
  loaderMessage: string;
  defaultLoadingMessage: string = "Loading..";

  constructor() {
    this.authStore = new AuthStore(this);
    this.productStore = new ProductStore(this);
    this.addOnStore = new AddOnStore(this);
    this.addOnOptstore = new AddOnOptionStore(this);
    this.cartStore = new CartStore(this);
    this.orderStore = new OrderStore(this);
    this.userStore = new UserStore(this);
    this.shopSettingsStore = new ShopSettingsStore(this);
    this.deliveryStore = new DeliveryStore(this);
    this.allergenStore = new AllergenStore(this);
    this.categoryStore = new CategoryStore(this);
    this.productOfferStore = new ProductOfferStore(this);
    this.voucherStore = new VoucherStore(this);
    this.showLoader = false;
    this.loaderMessage = this.defaultLoadingMessage;
  }

  showLoading(message?: string) {
    this.showLoader = true;
    if (message) this.loaderMessage = message;
  }

  hideLoading() {
    this.showLoader = false;
    this.loaderMessage = this.defaultLoadingMessage;
  }
}

const StoresContext = React.createContext(new RootStore());

// this will be the function available for the app to connect to the stores
export const useStores = () => React.useContext(StoresContext);
